import Cookies from 'js-cookie';

export default function ({ store }) {
    const token = Cookies.get('auth_token');
    if (token) {
        store.dispatch('FETCH_POSITIONS');
    }
}
